import OpShowTableRow from "./index.vue";
var opshowtablerow = {
  install: function install(Vue) {
    Vue.component("OpShowTableRow", OpShowTableRow);
  }
};
export default opshowtablerow;